var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21,
    r: 21,
    fill: "#FFE7E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6438 28.2599C20.1361 28.6537 20.8038 28.875 21.5 28.875C22.1962 28.875 22.8639 28.6537 23.3562 28.2599C23.8484 27.8661 24.125 27.332 24.125 26.775V9.975C24.125 9.41805 23.8484 8.8839 23.3562 8.49008C22.8639 8.09625 22.1962 7.875 21.5 7.875C20.8038 7.875 20.1361 8.09625 19.6438 8.49008C19.1516 8.8839 18.875 9.41805 18.875 9.975V26.775C18.875 27.332 19.1516 27.8661 19.6438 28.2599Z",
    fill: "#E83D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0416 31.9424C20.4733 31.654 20.9808 31.5 21.5 31.5C22.1962 31.5 22.8639 31.7766 23.3562 32.2688C23.8484 32.7611 24.125 33.4288 24.125 34.125C24.125 34.6442 23.971 35.1517 23.6826 35.5834C23.3942 36.015 22.9842 36.3515 22.5045 36.5502C22.0249 36.7489 21.4971 36.8008 20.9879 36.6996C20.4787 36.5983 20.011 36.3483 19.6438 35.9812C19.2767 35.614 19.0267 35.1463 18.9254 34.6371C18.8242 34.1279 18.8761 33.6001 19.0748 33.1205C19.2735 32.6408 19.6099 32.2308 20.0416 31.9424Z",
    fill: "#E83D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation_mark.da83e05400b1d7d1849529ff0b9b9482.svg";
export { ForwardRef as ReactComponent };